module.exports = __webpack_public_path__ + "img/contur-focus-green.5cc3d1ac.svg";